import { Flex, Heading, HStack, Image, Box, Link, useMediaQuery } from '@chakra-ui/react';
import NavActionsIcons from './NavActionsIcons';
import { onLink } from '../../handlers';
import DownloadModal from '../Modal/DownloadModal';
import CareerSummaryModal from '../Modal/CareerSummaryModal';
import NotesModal from '../Preview/components/Notes/NotesModal';
import NotesUtils from '../Preview/components/Notes/utils';
import { getHelpCenterLink } from './utils';
const helpCenterLink = getHelpCenterLink();
const DesktopHeader = ({ props }) => {
  const stateProps = props.stateProps;
  const sectionName = stateProps.sectionData.sectionName;
  const notesUtils = new NotesUtils(stateProps, sectionName);
  const formikProps = props.formikProps;
  const isDesktop = useMediaQuery('(min-width: 768px)', {ssr:false})
  const appType = window.appType;
  if (isDesktop[0] === true) {
    return (
      <Flex
        flexDirection="row"
        justifyContent="space-between"
        alignItems="center"
        maxWidth="1400px"
        width="100%"
      >
        <NotesModal props={props} notesUtils={notesUtils} />
        <DownloadModal
          stateProps={stateProps} />
        <HStack>
          <Link
            href="https://resumescripter.com/explorersworks">
          <Image
            src="/app/images/site-header-logo.png"
            alt="RS Works Logo"
            height="28px"
            paddingRight="20px"
          />
          </Link>
          {(appType !== 'cm' && appType !=='int' && appType !== 'mi' && appType !== 'city') &&
          <Link
            key="resumes"
            onClick={() =>
              onLink(false, formikProps, stateProps, 'resumes')
            }
          >
            <Heading variant="navMenu">My Resumes</Heading>
          </Link>
          }
          {(appType !== 'cm' && appType !=='int' && appType !== 'mi' && appType !== 'city' && sectionName !== 'resumes') &&
            <Box display="flex">
              <Link
                key="interview"
                onClick={() =>
                  onLink(false, formikProps, stateProps, 'interview')
                }
              >
                <Heading variant="navMenu">AI Interview Coach</Heading>
              </Link>
              <Link
                key="interview_header"
                onClick={() =>
                  onLink(false, formikProps, stateProps, 'new-aptitude', 0, 'section', '', props)
                }
              >
                <Heading variant="navMenu">Career Matchmaker</Heading>
              </Link></Box>
          }
          <Link href={helpCenterLink} isExternal>
            <Heading variant="navMenu">Help Center</Heading>
          </Link>
        </HStack>
        <NavActionsIcons props={props} />
      </Flex>
    );
  } else {
    return null;
  }
};

export default DesktopHeader;